module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div id=\"slate__stations__selection\" class=\"slate\">\n    <div class=\"slate__wrapper\">\n        <div class=\"slate__title\">")
    ; __append(escapeFn( title ))
    ; __append("</div>\n        <div class=\"slate__description\">\n            ")
    ;  for(var i = 0; i < stations.length; i++) { 
    ; __append("\n                <div class=\"station__box\" data-station=\"")
    ; __append(escapeFn( stations[i].station ))
    ; __append("\">\n                    ")
    ;  if(stations[i].assets) { 
    ; __append("\n                        <img src=\"")
    ; __append(escapeFn( CBS.Registry.imageHost ))
    ; __append("/base/")
    ; __append(escapeFn( stations[i].assets.small_logo_selected ))
    ; __append("\"\n                             alt=\"station logo\" class=\"station__box__logo\">\n                    ")
    ;  } 
    ; __append("\n                    <div class=\"station__box__title\">")
    ; __append(escapeFn( stations[i].name ))
    ; __append("</div>\n                    <div class=\"station__box__subtitle\">")
    ; __append(escapeFn( stations[i].market ))
    ; __append("</div>\n                </div>\n            ")
    ;  } 
    ; __append("\n        </div>\n    </div>\n</div>\n")
  }
  return __output;

}